export function paginator(totalItems, perPage, specifiedPage) {
  const totalPages = Math.ceil(totalItems / perPage);
  const firstPage = totalPages > 0 ? 1 : null;
  const lastPage = totalPages > 0 ? totalPages : null;
  let currentPage = null;
  let isFirstPage = null;
  let isLastPage = null;
  let previousPage = null;
  let nextPage = null;
  let fromCount = null;
  let toCount = null;
  if (totalPages > 0) {
    currentPage = Math.max(Math.min(specifiedPage, lastPage), firstPage);
    isFirstPage = currentPage === firstPage;
    isLastPage = currentPage === lastPage;
    previousPage = currentPage > firstPage ? currentPage - 1 : null;
    nextPage = currentPage < lastPage ? currentPage + 1 : null;
    fromCount = perPage * (currentPage - 1) + 1;
    toCount = Math.min(perPage * currentPage, totalItems);
  }
  return {
    totalItems,
    perPage,
    specifiedPage,
    totalPages,
    firstPage,
    lastPage,
    currentPage,
    isFirstPage,
    isLastPage,
    previousPage,
    nextPage,
    fromCount,
    toCount
  };
}
export function getPage(index, current) {
  return {
    index,
    active: index === current
  };
}
export function getPages(current, totalPages, around) {
  const range = [];
  const completeRange = [];
  let progressionIndex = 0;
  if (around > 0 || current === 1) {
    range.push(1);
  }
  if (totalPages <= 1) {
    return [getPage(1, current)];
  }
  for (let i = current - around; i <= current + around; i++) {
    if (i < totalPages && i > 1) {
      range.push(i);
    }
  }
  if (around > 0 || current === totalPages) {
    range.push(totalPages);
  }
  range.forEach(pageNumber => {
    if (pageNumber - progressionIndex !== 1 && around > 0) {
      completeRange.push(null);
    }
    completeRange.push(getPage(pageNumber, current));
    progressionIndex = pageNumber;
  });
  return completeRange;
}
//# sourceMappingURL=paginator.js.map